import { render, staticRenderFns } from "./CategorySection.vue?vue&type=template&id=00d4ef43&scoped=true&"
import script from "./CategorySection.vue?vue&type=script&lang=js&"
export * from "./CategorySection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d4ef43",
  null
  
)

export default component.exports